<template>
  <v-card class="mt-3">
    <v-card-title>
      <div>
        <div class="headline">Standard Comm/Disc Rates</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review remove @review="doReview(props.item)" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Add Standard Comm/Disc Rate
        <v-icon right>mdi-sale</v-icon>
      </v-btn>
    </v-card-text>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Standard Comm/Disc Rate?
      <div class="title">{{deleteStdCommDiscRateInfo}}</div>
      <div class="title">{{deleteStdCommDiscRate}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { PRODUCT_STDCOMMDISCFACT_TABMENU } from '@/store/types'
import { appID } from '@/const/underwriting'

export default {
  data() {
    return {
      columns: [
        { text: 'Commission Gross/Net', align: 'left', value: 'commGN', sortable: false },
        { text: 'Commission %', align: 'left', value: 'commPct', sortable: false },
        { text: 'Discount %', align: 'left', value: 'discPct', sortable: false },
        { text: 'Effective Date', align: 'left', value: 'displayEffDate', sortable: false },
        { text: 'End Date', align: 'left', value: 'endDate', sortable: false },
        { text: 'Factor 1', align: 'left', value: 'fact1', sortable: false },
        { text: 'Factor 2', align: 'left', value: 'fact2', sortable: false },
        { text: 'Factor 3', align: 'left', value: 'fact3', sortable: false },
        { text: 'Factor 4', align: 'left', value: 'fact4', sortable: false },
        { text: 'Factor 5', align: 'left', value: 'fact5', sortable: false },
        { text: 'Factor 6', align: 'left', value: 'fact6', sortable: false },
        { text: 'Protect Commission', align: 'left', value: 'protComm', sortable: false },
        { text: 'Protect Discount', align: 'left', value: 'protDisc', sortable: false }
      ],
      selectedColumns: [ 'commGN', 'commPct', 'discPct', 'fact1', 'fact2', 'fact3', 'fact4', 'fact5', 'fact6', 'displayEffDate' ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedStdCommDiscRate: undefined,
      deleteStdCommDiscRate: '',
      deleteStdCommDiscRateInfo: ''
    }
  },
  computed: {
    productAppID() {
      return this.$store.state.productManagement.product.appID
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'stdCommDiscRates': function(value) {
      this.items = value
    }
  },
  methods: {
    doReview(data) {
      const commitData = {
        stdCommDiscFactTab: 2,
        displayFactReviewTab: true,
        displayRateTab: true
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscRateReview', params: { rateId: data } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscRateReview', params: { rateId: data } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscRateReview', params: { rateId: data } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscRateReview', params: { rateId: data } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscRateReview', params: { rateId: data } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscRateReview', params: { rateId: data } })
      }
    },
    doNew() {
      const commitData = {
        stdCommDiscFactTab: 2,
        displayFactReviewTab: true,
        displayRateTab: true
      }
      this.$store.commit(PRODUCT_STDCOMMDISCFACT_TABMENU, commitData)
      if (this.productAppID === appID.MOTOR) {
        this.$router.push({ name: 'motorStdCommDiscRateReview', params: { rateId: 'New' } })
      } else if (this.productAppID === appID.TRAVEL) {
        this.$router.push({ name: 'travelStdCommDiscRateReview', params: { rateId: 'New' } })
      } else if (this.productAppID === appID.FIRE) {
        this.$router.push({ name: 'fireStdCommDiscRateReview', params: { rateId: 'New' } })
      } else if (this.productAppID === appID.CARGO) {
        this.$router.push({ name: 'cargoStdCommDiscRateReview', params: { rateId: 'New' } })
      } else if (this.productAppID === appID.MAID) {
        this.$router.push({ name: 'maidStdCommDiscRateReview', params: { rateId: 'New' } })
      } else if (this.productAppID === appID.PACKAGE) {
        this.$router.push({ name: 'packageStdCommDiscRateReview', params: { rateId: 'New' } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedStdCommDiscRate = data
        this.deleteStdCommDiscRate = data.fact1 + ' / ' + data.fact2 + ' / ' + data.fact3 + ' / ' + data.fact4 + ' / ' + data.fact5 + ' / ' + data.fact6
        this.deleteStdCommDiscRateInfo = data.commGN + ' / Comm:' + data.commPct + '%' + ' / Disc:' + data.discPct + '%'
      }
    },
    doRemove() {
      this.$emit('doRemove', this.selectedStdCommDiscRate)
    }
  },
  props: {
    product: {
      type: String,
      default: ''
    },
    stdCommDiscRates: {
      type: Array,
      default: () => []
    }
  },
  created() {
    if (this.stdCommDiscRates && this.stdCommDiscRates.length > 0) {
      this.items = this.stdCommDiscRates
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
